// app.config.ts
export default defineAppConfig({
    defaultMarket: 'se' as const,
    markets: { uk: 'uk', de: 'de', pt: 'pt', se: 'se', at: 'at' },
    marketToCountry: {
        uk: 'GB' as const,
        de: 'DE' as const,
        pt: 'PT' as const,
        se: 'SE' as const,
        at: 'AT' as const,
    },
    // Note language / country is not a 1:1 mapping, so for example 'AT' is not included here
    languageToCountry: { en: 'GB', de: 'DE', pt: 'PT', sv: 'SE' },

    // New locale-based config
    locales: ['en-gb', 'en-se', 'en-de', 'en-at', 'en-pt', 'sv-se', 'de-de', 'de-at', 'pt-pt'] as const,
    defaultLocale: 'en-gb' as const,
    localeToMarket: {
        'en-gb': 'uk' as const,
        'en-se': 'se' as const,
        'en-de': 'de' as const,
        'en-at': 'at' as const,
        'en-pt': 'pt' as const,
        'sv-se': 'se' as const,
        'de-de': 'de' as const,
        'de-at': 'at' as const,
        'pt-pt': 'pt' as const,
    },
    localeToLanguage: {
        'en-gb': 'en' as const,
        'en-se': 'en' as const,
        'en-de': 'en' as const,
        'en-at': 'en' as const,
        'en-pt': 'en' as const,
        'sv-se': 'sv' as const,
        'de-de': 'de' as const,
        'de-at': 'de' as const,
        'pt-pt': 'pt' as const,
    },
    marketToDefaultLocale: {
        uk: 'en-gb' as const,
        se: 'sv-se' as const,
        de: 'de-de' as const,
        at: 'de-at' as const,
        pt: 'pt-pt' as const,
    },
    // Available languages per market (for language dropdown filtering)
    marketToAvailableLocales: {
        uk: ['en-gb'] as const,
        se: ['sv-se', 'en-se'] as const,
        de: ['de-de', 'en-de'] as const,
        at: ['de-at', 'en-at'] as const,
        pt: ['pt-pt', 'en-pt'] as const,
    },
});
